
import { defineComponent } from 'vue'
import { UIState_uiGlobalNavbarState } from '@/store/types/types'
export default defineComponent({
  name: 'About',
  mounted () {
    this.$store.commit('uiStateModule/updateGlobalNavbarState', UIState_uiGlobalNavbarState.Shown)
  }
})
